/* Tonoko — buscador por nº de parte / modelo de impresora / nº de cartucho.
   Lee productos REALES emitidos por la sección (JSON inline). Sin imports (asset plano de Shopify). */
(function(){
  function el(tag, props){
    props = props || {};
    var n = document.createElement(tag), kids = [].slice.call(arguments, 2);
    for (var k in props){ var val = props[k]; if (val == null || val === false) continue;
      if (k === 'class') n.className = val;
      else if (k === 'text') n.textContent = val;
      else if (k in n && k !== 'list') n[k] = val; else n.setAttribute(k, val); }
    kids.forEach(function(c){ if (c == null || c === false) return; n.appendChild(c.nodeType ? c : document.createTextNode(String(c))); });
    return n;
  }
  function card(p, eleph){
    var media = p.image
      ? el('div', {class:'pcard__media'}, el('img', {src:p.image, alt:p.title, loading:'lazy', width:'320', height:'320'}))
      : el('div', {class:'pcard__media pcard__media--ph'}, el('img', {src:eleph, alt:'', 'aria-hidden':'true', width:'40', height:'40'}), el('span', {text:'Foto en producción'}));
    var price = [];
    if (p.compare && p.compare !== p.price) price.push(el('s', {class:'pcard__was tnum', text:p.compare}));
    if (p.price) price.push(el('strong', {class:'tnum', text:p.price}));
    var body = el('div', {class:'pcard__body'},
      el('span', {class:'pcard__tag', text: p.line === 'propia' ? 'Marca propia' : 'Compatible'}),
      el('a', {class:'pcard__title', href: p.url || '#', text: p.title}),
      p.yield ? el('p', {class:'pcard__yield tnum', text:'Rinde hasta ' + p.yield + ' págs'}) : null,
      p.oem ? el('p', {class:'pcard__oem', text:'Equivale a: ' + p.oem}) : null,
      el('div', {class:'pcard__price'}, price.length ? price[0] : null, price.length > 1 ? price[1] : null),
      el('a', {class:'pcard__cta tnk-btn tnk-btn--cta', href: p.url || '#', text:'Ver'}));
    return el('article', {class:'pcard'}, media, body);
  }
  function renderInto(box, list, eleph){
    box.replaceChildren();
    if (!list.length){ box.appendChild(el('p', {class:'tnk-empty', text:'No encontramos un match exacto. Escríbenos y te ayudamos.'})); return; }
    list.forEach(function(p){ box.appendChild(card(p, eleph)); });
  }

  function init(){
    var root = document.querySelector('[data-tnk-finder]'); if (!root) return;
    var dataEl = root.querySelector('[data-tnk-products]');
    var prods = [];
    try { prods = JSON.parse(dataEl.textContent); } catch(e){ prods = []; }
    var results = root.querySelector('#tnk-results');
    var eleph = (results && results.dataset.eleph) || '';
    // preparar tokens (split del blob 'tok', filtrar >=4 para nº de parte completo -> código corto)
    prods.forEach(function(p){ p.tokens = (p.tok || '').split(/\s+/).filter(function(t){ return t.length >= 4; }); });

    var brand = root.querySelector('#tnk-brand'), model = root.querySelector('#tnk-model'),
        models = root.querySelector('#tnk-models'), hint = root.querySelector('#tnk-hint'),
        form = root.querySelector('#tnk-form');

    var brands = [];
    prods.forEach(function(p){ if (p.brand && brands.indexOf(p.brand) < 0) brands.push(p.brand); });
    brands.sort();
    brands.forEach(function(b){ brand.appendChild(el('option', {value:b, text:b})); });

    function fillSuggestions(){
      models.replaceChildren();
      var src = brand.value ? prods.filter(function(p){ return p.brand === brand.value; }) : prods;
      var toks = [];
      src.forEach(function(p){ p.tokens.forEach(function(t){ if (toks.indexOf(t) < 0) toks.push(t); }); });
      toks.slice(0, 40).forEach(function(t){ models.appendChild(el('option', {value:t})); });
    }
    fillSuggestions();

    function matchQuery(p, raw){
      if (!raw) return true;
      var ql = raw.toLowerCase().trim();
      if (ql.length >= 2 && (p.search || '').indexOf(ql) > -1) return true;        // substring: pedazo de cartucho / modelo
      var qa = raw.toUpperCase().replace(/[^A-Z0-9]/g, '');                         // nº de parte completo -> código corto
      if (qa.length >= 4){ for (var i = 0; i < p.tokens.length; i++){ if (p.tokens[i].length >= 4 && qa.indexOf(p.tokens[i]) > -1) return true; } }
      return false;
    }
    function run(scroll){
      var bsel = brand.value, q = (model.value || '').trim();
      var list = prods.filter(function(p){ return (!bsel || p.brand === bsel) && matchQuery(p, q); });
      if (!bsel && !q) list = prods.slice(0, 4);
      hint.textContent = (bsel || q) ? (list.length + ' resultado' + (list.length === 1 ? '' : 's')) : '';
      renderInto(results, list, eleph);
      if (scroll) results.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth', block:'nearest'});
    }
    brand.addEventListener('change', function(){ fillSuggestions(); run(false); });
    model.addEventListener('input', function(){ run(false); });
    form.addEventListener('submit', function(e){ e.preventDefault(); run(true); });

    run(false);
    var heroes = document.querySelector('[data-tnk-heroes]');
    if (heroes) renderInto(heroes, prods.slice(0, 6), eleph);
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
